import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './components/Home';
import Projects from './components/Projects';
import Resume from './components/Resume';
import About from './components/About';
import Contact from './components/Contact';
import './styles/App.scss';


function App() {
  return (
    <div className="App">
      <Navigation />

      <Switch>
        <Route path='/resume' component={Resume} />
        <Route path='/projects' component={Projects} />
        <Route path='/about' component={About} />
        <Route exact path='/' component={Home} />
      </Switch>

      <Contact />
      <Footer />
    </div>
  );
}

export default App;
